<template>
  <div>
    <!--  射门分布数据-->
    <div
      class="container pointTheme_container"
      v-if="isShowPointThemeFlag"
      :style="{
        '--mixtmt_pointTheme_bg': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/pointTheme_bg.png')`,
      }"
    >
      <div class="titleArea">
        <span class="titleArea_bg"></span>
      </div>
      <div class="container_bgColor">
        <div class="pointTheme_map">
          <span
            class="point_item"
            v-for="(point, index) in pointDataList"
            :key="index"
            :class="point.type ? `type_${point.type}` : ''"
            :style="{ bottom: `${point.bottom}%`, left: `${point.left}%` }"
          ></span>
        </div>
        <div
          class="pointTheme_tipArea"
          v-if="pintDataTexts && pintDataTexts.length > 0"
        >
          <span class="tip_itemArea">
            <span
              class="tip_item"
              v-text="_valFormatHandler(pintDataTexts[0], '进球')"
            ></span>
            <span
              class="tip_item"
              v-text="_valFormatHandler(pintDataTexts[1], '被扑出')"
            ></span>
            <span
              class="tip_item"
              v-text="_valFormatHandler(pintDataTexts[2], '射偏')"
            ></span>
          </span>
          <span
            class="pointText"
            v-text="_valFormatHandler(pintDataTexts[3], '进球率', '%')"
          ></span>
        </div>
        <div class="circleArea">
          <div
            class="circleItem"
            v-for="(item, index) in circleList"
            :key="index"
          >
            <CircleDom
              :centerText="item.centerText"
              :svgDataArr="item.svgDataArr"
            ></CircleDom>
            <span class="circleTitle" v-text="item.circleTitle"></span>
          </div>
          <!-- <div class="circleItem">
              <Circle :centerText="'40%'"></Circle>
              <span class="circleTitle" v-text="'左侧'"></span>
            </div>
            <div class="circleItem">
              <Circle :centerText="'40%'"></Circle>
              <span class="circleTitle" v-text="'左侧'"></span>
            </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleDom from './Circle.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'html_point_layout',
  mixins: [cup_base_data_mixin],
  components: {
    CircleDom,
  },
  props: {
    resData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    matchId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isShowPointThemeFlag: true, //控制是否显示射门分布主题
      isSelectPop: false,
      isSelectTeamPop: false,
      isSelectPlayerPop: false,
      actPlayer: {},
      actTeam: {},
      selectObj: {
        type: '',
        title: '',
        list: '',
      },
      //   teamList: null,
      //   pointDatas: [],
      teamList: [
        {
          teamName: '沙特阿拉伯',
          teamId: '1',
          act: true,
          playerList: [
            {
              playerName: '1球员球员球员球员球员',
              playerId: 1,
              playerLogo: '',
              teamId: '1',
              act: false,
            },
            {
              playerName: '2球员球员球员球员球员',
              playerId: 2,
              playerLogo: '',
              teamId: '1',
              act: false,
            },
            {
              playerName: '3球员球员球员球员球员',
              playerId: 3,
              playerLogo: '',
              teamId: '1',
              act: false,
            },
            {
              playerName: '4球员球员球员球员球员',
              playerId: 4,
              playerLogo: '',
              teamId: '1',
              act: false,
            },
          ],
        },
        {
          teamName: '巴西',
          teamId: '2',
          act: false,
          playerList: [
            {
              playerName: '1球员球员球员球员球员',
              playerId: 1,
              playerLogo: '',
              teamId: '2',
              act: false,
            },
            {
              playerName: '2球员球员球员球员球员',
              playerId: 2,
              playerLogo: '',
              teamId: '2',
              act: false,
            },
            {
              playerName: '3球员球员球员球员球员',
              playerId: 3,
              playerLogo: '',
              teamId: '2',
              act: false,
            },
            {
              playerName: '4球员球员球员球员球员',
              playerId: 4,
              playerLogo: '',
              teamId: '2',
              act: false,
            },
          ],
        },
      ],

      pointDatas: [
        // x 和 y值，整数或者最多保留1位小数（里面主要是x值，y值到无所谓）
        // type：1进球；2扑出；3射偏
        {
          name: '扑出',
          x: 50,
          y: 100,
          type: 2,
        },
        {
          name: '进球',
          x: 50,
          y: 0,
          type: 1,
        },
        {
          name: '扑出',
          x: 50,
          y: 19,
          type: 2,
        },
        {
          name: '扑出',
          x: 54.7,
          y: 40,
          type: 2,
        },
        {
          name: '扑出',
          x: 50,
          y: 39,
          type: 2,
        },
        {
          name: '进球',
          x: 50,
          y: 38,
          type: 1,
        },
        {
          name: '进球',
          x: 54.7,
          y: 19,
          type: 1,
        },
        {
          name: '左上门框上',
          x: 54.9,
          y: 30,
          type: 3,
        },
        {
          name: '左上门框外',
          x: 55.9,
          y: 42,
          type: 3,
        },

        {
          name: '左上门框外边界',
          x: 59.2,
          y: 60,
          type: 3,
        },
        {
          name: '右上门框外边界',
          x: 44.1,
          y: 60,
          type: 3,
        },
        {
          name: '右门框',
          x: 44.5,
          y: 19,
          type: 3,
        },
        {
          name: '右门框',
          x: 44.2,
          y: 19,
          type: 3,
        },
        {
          name: '右门框',
          x: 45.1,
          y: 19,
          type: 3,
        },
        {
          name: '上门框',
          x: 40.7,
          y: 100,
          type: 3,
        },
        {
          name: '上门框',
          x: 55.9,
          y: 100,
          type: 3,
        },
      ],
      pintDataTexts: null,
      svgOrignDataArr: [30, 20, 10], //这里面必须是三个元素，占位置用的，没有的可以0||null占位
      tipText: '进攻动量越大，球队进攻威胁越大。',
    }
  },
  created() {},
  beforeRouteLeave() {
    this.teamList = null
  },
  computed: {
    circleList() {
      const data = this.svgOrignDataArr.map((item, index) => {
        let text = ''
        if (index == 0) {
          text = '左侧'
        } else if (index == 1) {
          text = '中间'
        } else {
          text = '右侧'
        }
        // 单个颜色圆环
        // return {
        //   circleTitle: text,
        //   centerText: [item ? `${item}%` : "0", '传球率'],
        //   svgDataArr: [
        //     {
        //       val: this._valFormatHandler(item),
        //       perVal: this._valFormatHandler(item),
        //       strokeClass: "svg_color0",
        //       key: "home", //1
        //     },
        //     {
        //       val: 0,
        //       perVal: 0,
        //       strokeClass: "svg_color_notData",
        //       key: "away", //1
        //     },
        //   ],
        // };
        if (item && item instanceof Array) {
          // 2种颜色以上圆环，有几种颜色，需要几个元素占位，没有值的用0占位；组件里面值配了3种颜色，大于3个需要添加配色
          const total = item.reduce((pre, next) => {
            return pre + next
          }, 0)
          let curPerVal = 0
          return {
            circleTitle: text,
            centerText: ['13', '比赛'],
            svgDataArr: item.map((cell, cIndex) => {
              let cellPerVal = 0
              if (cIndex == item.length - 1) {
                cellPerVal = 100 - curPerVal
              } else {
                cellPerVal = Math.round((cell / total) * 100)
                curPerVal += cellPerVal
              }
              return {
                val: item ? this._valFormatHandler(cell) : 0,
                perVal: item ? this._valFormatHandler(cellPerVal) : 0,
                strokeClass: `svg_color${cIndex}`,
                key: `key_${cIndex}`, //1
              }
            }),
          }
        } else {
          // 2种颜色圆环
          return {
            circleTitle: text,
            centerText: item ? `${item}%` : '0',
            svgDataArr: [
              {
                val: this._valFormatHandler(item),
                perVal: this._valFormatHandler(item),
                strokeClass: 'svg_color0',
                key: 'home', //1
              },
              {
                val: item ? 100 - this._valFormatHandler(item) : 0,
                perVal: item ? 100 - this._valFormatHandler(item) : 0,
                strokeClass: 'svg_color1',
                key: 'away', //1
              },
            ],
          }
        }
      })
      return data
    },
    pointDataList() {
      // 源数据点坐标的x轴范围为：40.7~59.3；y轴范围为0~100
      // 按照opta数据图空间比例，分为2种情况：
      // 第一种：y轴在60~100
      // 第二种：y轴在0~60
      const hightArea = [
        {
          //球门上方，高度60~100区域
          xArea: [45.2, 54.8], //opta数据图x轴坐标点
          yArea: [60, 100], //opta数据图y轴坐标点
          mapSize: [280, 102], //UI图对应该区域的宽高（px）
          base: [50, 60], //xy轴坐标的起始点
          start: [50, 60.1], //第一个元素left的起始百分比，第二个是top的起始百分比
        },
        {
          //门右外，高度60~100区域
          xArea: [40.7, 44.1],
          yArea: [60, 100],
          mapSize: [106, 102],
          base: [44.1, 60],
          start: [72.3, 60.1],
        },
        {
          //门左外，高度60~100区域
          xArea: [55.9, 59.3],
          yArea: [60, 100],
          mapSize: [106, 102],
          base: [55.8, 60],
          start: [27.7, 60.1],
        },
      ]
      const closeArea = [
        {
          //门右外
          xArea: [40.7, 44.1],
          yArea: [0, 60],
          mapSize: [106, 215],
          base: [44.1, 0],
          start: [72.3, 0],
        },
        {
          // 右门框
          xArea: [44.2, 45.1],
          yArea: [0, 38],
          mapSize: [8, 140],
          base: [45.1, 0],
          start: [69.5, 0],
        },
        {
          //球门进球有效区域且包括上门框，但不包括左右门框
          xArea: [45.2, 54.8],
          yArea: [0, 38],
          mapSize: [280, 140],
          base: [50, 0],
          start: [50, 0],
        },
        {
          //左门框
          xArea: [54.9, 55.8],
          yArea: [0, 38],
          mapSize: [8, 140],
          base: [54.8, 0],
          start: [30.5, 0],
        },
        {
          // 门左外
          xArea: [55.9, 59.3],
          yArea: [0, 60],
          mapSize: [106, 215],
          base: [55.8, 0],
          start: [27.7, 0],
        },
      ]
      console.debug('pointDataList:', this.pointDatas)
      return this.pointDatas.map((item) => {
        let left = 0
        let bottom = 0
        let flag = false
        let area = []
        if (item.y <= 60) {
          area = closeArea
        } else {
          area = hightArea
        }
        for (let i = 0; i < area.length; i++) {
          const { xArea, yArea, mapSize, base, start } = area[i]
          if (item.x <= xArea[1] && item.x >= xArea[0]) {
            let diff = (item.x - base[0]).toFixed(3)
            let direction = null
            let directionNum = -1
            if (item.x > 50) {
              // left
              direction = 'left'
            } else if (diff < 50) {
              // right
              direction = 'right'
              directionNum = -1
            } else {
              // center
              direction = 'center'
              left = 50
              directionNum = 1
            }
            console.debug('direction:', direction, item.x, diff)
            if (direction) {
              flag = true
            }
            left =
              start[0] +
              directionNum *
                (
                  (((mapSize[0] / (xArea[1] - xArea[0])) * diff) / 710) *
                  100
                ).toFixed(2)
            bottom =
              start[1] +
              1 *
                (
                  (((mapSize[1] / (yArea[1] - yArea[0])) * (item.y - base[1])) /
                    340) *
                  100
                ).toFixed(2)
            console.debug('left:', left, bottom, start[1])
            if (flag) {
              break
            }
          }
        }
        return {
          left,
          bottom,
          type: item.type,
        }
      })
    },
  },
  methods: {
    initSelect() {
      this.actTeam = this.teamList[0]
      this.actPlayer = this.actTeam.playerList[0]
      this.changePlayerHandler(this.actPlayer)
    },
    changePlayerHandler(player) {
      this.pointDatas = player.pointDatas
      this.svgOrignDataArr = player.svgOrignDataArr
      this.pintDataTexts = player.pintDataTexts
    },
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = 0
      } else {
        if (text) {
          data = `${text} ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
@import './vw.scss';
* {
  box-sizing: border-box;
}
.container {
  width: 100%;
  padding: 0 vw(10);
  margin-bottom: vw(20);
}
.pointTheme_container {
  .titleArea {
    position: relative;
    width: 100%;
    height: vw(40);
    padding-bottom: vw(15);
    .titleArea_bg {
      display: block;
      width: 100%;
      height: vw(25);
      background-size: auto 100%;
      background-position: left top;
      background-repeat: no-repeat;
      /* background-image: url(../view/img/pointData_title_icon.png); */
    }
  }
  .container_bgColor {
    width: 100%;
    background-color: #5f162e;
    border-radius: vw(10);
    .selectArea {
      position: relative;
      width: 100%;
      height: vw(44);
      padding: 0 vw(10);
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .teamArea {
        width: auto;
        margin-right: vw(24);
        .teamName {
          font-size: vw(14);
          color: #fff;
          padding-right: vw(13);
        }
        .playerInfor {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          height: vw(36);
          color: rgba(255, 255, 255, 0.65);
          padding-right: vw(13);
          .playerLogo {
            width: vw(24);
            height: vw(24);
            border-radius: 50%;
            overflow: hidden;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .playerName {
            max-width: 40vw;
            padding-left: vw(5);
            font-size: vw(14);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.act {
            color: rgba(255, 255, 255, 1);
            background-color: rgba(238, 238, 238, 0.2);
            border-radius: vw(8);
          }
        }
      }
    }
    .pointTheme_map {
      position: relative;
      width: 100%;
      height: vw(170);
      background-position: left top;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-image: var(--mixtmt_pointTheme_bg);
      .point_item {
        display: block;
        position: absolute;
        z-index: 10;
        width: vw(10);
        height: vw(10);
        border-radius: 50%;
        margin-bottom: vw(12 - 10);
        transform: translate(-50%, -50%);
        opacity: 0;
        transition: opacity 1s linear;
        &.type_1 {
          border: 1px solid rgba(0, 207, 183, 1);
          background-color: rgba(0, 207, 183, 0.3);
          opacity: 1;
        }
        &.type_2 {
          border: 1px solid rgba(252, 171, 4, 1);
          background-color: rgba(252, 171, 4, 0.3);
          opacity: 1;
        }
        &.type_3 {
          border: 1px solid rgba(246, 0, 73, 1);
          background-color: rgba(246, 0, 74, 0.3);
          opacity: 1;
        }
      }
    }
    .pointTheme_tipArea {
      width: 100%;
      height: vw(32);
      padding: vw(10) 0;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      .tip_itemArea {
        width: calc(100% - #{vw(106)});
        display: flex;
        display: -webkit-flex;
        justify-content: space-evenly;
        align-items: center;
        .tip_item {
          position: relative;
          width: auto;
          padding-left: vw(17);
          font-size: vw(12);
          line-height: 1;
          &::before {
            position: absolute;
            top: 50%;
            left: 0;
            z-index: 2;
            transform: translateY(-50%);
            content: '\20';
            display: block;
            width: vw(12);
            height: vw(12);
            border-radius: 50%;
          }
          &:first-child {
            &::before {
              background-color: rgba(0, 207, 183, 0.3);
              border: 1px solid rgba(0, 207, 183, 1);
            }
          }
          &:nth-child(2) {
            &::before {
              background-color: rgba(252, 171, 4, 0.3);
              border: 1px solid rgba(252, 171, 4, 1);
            }
          }
          &:nth-child(3) {
            &::before {
              background-color: rgba(246, 0, 73, 0.3);
              border: 1px solid rgba(246, 0, 73, 1);
            }
          }
        }
      }
      .pointText {
        position: relative;
        width: vw(106);
        text-align: center;
        font-size: vw(12);
        line-height: 1;
        &::before {
          position: absolute;
          top: 50%;
          left: 0;
          z-index: 2;
          transform: translateY(-50%);
          content: '\20';
          display: block;
          width: 1px;
          height: vw(12);
          background-color: #fff;
        }
      }
    }
    .circleArea {
      padding: vw(20) 0;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-evenly;
      align-items: center;
      .circleItem {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
    }
  }
}
.matchStateTheme_container {
  .titleArea {
    position: relative;
    width: 100%;
    height: vw(40);
    padding-bottom: vw(15);
    .titleArea_bg {
      display: block;
      width: 100%;
      height: vw(25);
      background-size: auto 100%;
      background-position: left top;
      background-repeat: no-repeat;
      /* background-image: url(../view/img/matchState_title_icon.png); */
    }
    .tipArea {
      position: absolute;
      left: 30%;
      top: 0;
      z-index: 2;
      width: auto;
      height: vw(25);
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .tipArea_text {
        font-size: vw(12);
        color: #fff;
        padding-right: vw(4);
      }
    }
  }
  .container_bgColor {
    padding: vw(10) vw(10) vw(5) 0;
    width: 100%;
    background-color: #5f162e;
    border-radius: vw(10);
  }
}

.keyEventTheme_container {
  .titleArea {
    position: relative;
    width: 100%;
    height: vw(40);
    padding-bottom: vw(15);
    .titleArea_bg {
      display: block;
      width: 100%;
      height: vw(25);
      background-size: auto 100%;
      background-position: left top;
      background-repeat: no-repeat;
      /* background-image: url(../view/img/keyEvent_title_icon.png); */
    }
  }
  .container_bgColor {
    padding: vw(10) 0;
    width: 100%;
    background-color: #5f162e;
    border-radius: vw(10);
  }
}
.team_popList {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 vw(10);
}
.teamItem {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  height: vw(36);
  font-size: vw(14);
  color: rgba(255, 255, 255, 0.65);
  &.act {
    color: rgba(255, 255, 255, 1);
    background-color: rgba(238, 238, 238, 0.2);
    border-radius: vw(8);
  }
}
</style>
